import busEvents from '@/helper/busEvents';

export const emitPlaySpinSound = () => {
  busEvents.emit('playSpinSound');
};

export const onPlaySpinSound = (callback: () => void) => {
  busEvents.on('playSpinSound', callback);
};

export const emitStopSpinSound = () => {
  busEvents.emit('stopSpinSound');
};
export const onStopSpinSound = (callback: () => void) => {
  busEvents.on('stopSpinSound', callback);
};

export const emitPlayWinSound = () => {
  busEvents.emit('playWinSound');
};
export const onPlayWinSound = (callback: () => void) => {
  busEvents.on('playWinSound', callback);
};

export const emitPlayBetSound = () => {
  busEvents.emit('playBetSound');
};
export const onPlayBetSound = (callback: () => void) => {
  busEvents.on('playBetSound', callback);
};

export const emitPlayTimeUpSound = () => {
  busEvents.emit('playTimeUpSound');
};
export const onPlayTimeUpSound = (callback: () => void) => {
  busEvents.on('playTimeUpSound', callback);
};

export const emitPlayRushBgSound = () => {
  busEvents.emit('PlayBgSound');
};
export const onPlayRushBgSound = (callback: () => void) => {
  busEvents.on('PlayBgSound', callback);
};
export const emitStopRushBgSound = () => {
  busEvents.emit('StopRushBgSound');
};
export const onStopRushBgSound = (callback: () => void) => {
  busEvents.on('StopRushBgSound', callback);
};
